/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("/camino.gltf");
  return (
    <group rotation={props.rotation} {...props} dispose={null}>
      <group rotation={[0, 0.78, 0]} scale={4.94}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane_1.geometry}
          material={materials["Material.003"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane_2.geometry}
          material={materials["Material.004"]}
        />
      </group>
      <group position={[0, -0.55, -4.19]} rotation={[0, 1.33, 0]} scale={0.34}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[-1.64, -0.62, -4.22]}
        rotation={[0, 1.33, 0]}
        scale={0.46}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle001_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle001_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[-4.6, -0.64, 0.09]}
        rotation={[-0.1, 1.33, 0]}
        scale={0.45}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle002_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle002_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[-4.48, -0.58, -1.5]}
        rotation={[-0.35, 1.32, 0.36]}
        scale={0.32}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle003_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle003_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[4.88, -0.6, 0.36]}
        rotation={[0.36, 1.31, -0.37]}
        scale={0.46}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle005_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle005_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[-0.39, -0.5, 4.14]}
        rotation={[-0.34, 1.32, 0.35]}
        scale={0.4}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle006_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle006_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group position={[0.8, -0.6, 3.87]} rotation={[0, 1.33, 0]} scale={0.32}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle007_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle007_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group
        position={[0.3, -0.77, -5.48]}
        rotation={[-0.1, 1.33, 0]}
        scale={0.34}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle008_1.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle008_2.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <group position={[4.1, -0.59, 0.95]} rotation={[0, 1.33, 0]} scale={0.22}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle009.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle009_1.geometry}
          material={materials["Material.002"]}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Coche.geometry}
        material={materials["default"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.luces.geometry}
        material={materials["Material.005"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.lucesatras.geometry}
        material={materials["Material.005"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.asiento.geometry}
        material={materials["Material.006"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.volante.geometry}
        material={materials["Material.006"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.ruedas.geometry}
        material={materials["Material.006"]}
        position={[0.14, 0.02, -0.08]}
        rotation={[Math.PI / 2, 0, -0.79]}
        scale={0.58}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube.geometry}
        material={nodes.Cube.material}
        position={[2.8, -0.46, 1.92]}
        scale={-0.27}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube001.geometry}
        material={nodes.Cube001.material}
        position={[2.7, -0.47, 2.34]}
        scale={-0.12}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube002.geometry}
        material={nodes.Cube002.material}
        position={[-2.91, -0.03, 0.18]}
        rotation={[-Math.PI, 1.46, -Math.PI]}
        scale={-0.27}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube003.geometry}
        material={nodes.Cube003.material}
        position={[-2.48, -0.04, 0.23]}
        rotation={[-Math.PI, 1.46, -Math.PI]}
        scale={-0.12}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube004.geometry}
        material={nodes.Cube004.material}
        position={[1.27, -0.08, -3.27]}
        rotation={[-Math.PI, 1.46, -Math.PI]}
        scale={-0.12}
      />
    </group>
  );
}

useGLTF.preload("/camino.gltf");
